
import Vue from 'vue'
import AppMixin from '@/_mixins/app'

import { serialise } from 'kitsu-core'
import { PSI } from '@/views/Project/PSI/types/psi'

import DialogTemplate from '@/_components/dialog/template/template.vue'

const PsiSettingsDialog = Vue.extend({
    mixins: [AppMixin],
    components: { DialogTemplate },

    props: {
        props: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            valid: false,
            loading: false,
            collision: false,
            psiCopy: null as null | PSI,
        }
    },

    computed: {
        project() {
            return this.props.project
        },
        psi(): PSI {
            return this.props.psi
        },
        updates() {
            return this.lodash.reduce(
                this.psiCopy,
                (result, value, key) => {
                    return this.psi
                        ? this.lodash.isEqual(value, this.psi[key])
                            ? result
                            : result.concat(key)
                        : []
                },
                []
            )
        },

        hasUpdates() {
            return this.updates.length > 0
        },
        formatedUpdates() {
            let newVals = {}
            this.updates.map((item) => {
                if (this.psiCopy) newVals[item] = this.psiCopy[item]
            })

            return newVals
        },
    },

    methods: {
        async handlePSI(event?) {
            event?.preventDefault()
            if (!this.psiCopy || !this.valid) {
                return
            }

            if (this.psiCopy.id) {
                await this.patchPSI()
            } else {
                await this.postPSI()
            }
        },
        async patchPSI() {
            if (this.psiCopy && this.valid) {
                this.loading = true
                let payload = serialise(this.psiCopy.type, {
                    id: this.psiCopy.id,
                    ...this.formatedUpdates,
                })

                let res = await this.patch(
                    this.psiCopy.links.self,
                    {
                        ...this.headersmixins,
                    },
                    payload,
                    this.formatedUpdates
                )

                if (res) {
                    if (res.type) {
                        this.$emit('close', res)
                    } else if (res.collisions) {
                        this.collision = res.collisions
                    }
                }

                this.loading = false
            }
        },

        async postPSI() {
            if (this.psiCopy && this.valid) {
                this.loading = true
                let payload = serialise(this.psiCopy.type, {
                    type: this.psi.type,
                    ...this.formatedUpdates,
                    project: this.psiCopy.project,
                })

                let res = await this.postRequest(
                    this.getURL({
                        path: `psis`,
                        base: this.psiBaseUrl,
                    }),
                    payload.data
                )

                if (res && res.type) {
                    this.$emit('close', res)
                }

                this.loading = false
            }
        },
    },

    mounted: function () {
        this.$nextTick(function () {
            this.psiCopy = this.lodash.cloneDeep(this.psi)
        })
    },
})

export default PsiSettingsDialog
